import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, useTranslation } from '@pascal/pascal-core';
import logoTable from '../../assets/images/baccarat/logo-baccarat-table.png';
import logoTableTurbo from '../../assets/images/baccarat/logo-turbo-baccarat-table.png';
import { TURBO_GAME_ID } from '../../enums/constants';

const Logo = observer(() => {
  const { gameId } = gameConfigStore;
  const t = useTranslation();
  const isTurbo = +gameId === TURBO_GAME_ID;
  return (
    <div className={`baccarat-logo-table ${isTurbo ? 'turbo' : ''}`}>
      <img className={isTurbo ? 'turbo' : ''} src={isTurbo ? logoTableTurbo : logoTable} alt='' />
      <p className={`baccarat-the-pays ${isTurbo ? 'turbo' : ''}`}>{t('TIE_PAYS_8_TO_1')}</p>
    </div>
  );
});

export default Logo;
